import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function AlreadyPairedDialog({ onOkClick, deviceName }) {
  const { t } = useTranslation();
  const button = {
    text: t("buttons.ok"),
    onClick: onOkClick
  };
  const text = t(`pairing.manually.enterCode.alreadyPairedDialog.text`, {
    value0: deviceName
  });
  const heading = t(`pairing.manually.enterCode.alreadyPairedDialog.heading`);

  return (
    <Dialog
      type="success"
      isOpen={true}
      buttons={[button]}
      heading={heading}
      text={text}
    />
  );
}
